// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bodyContainer__b44 {
  z-index: 0;
  display: flex;
  flex-direction: column;
  min-height: 44px;
  position: relative;
  padding: calc(var(--ring-unit) / 2);

  overflow: hidden;
  cursor: pointer;
}

.bodyContainer__b44.nonInteractive__a69 {
  cursor: default;
}

.bodyContainer__b44.variantBordered__fc5 {
  margin-bottom: calc(var(--ring-unit) / 2);
  border-radius: calc(var(--ring-unit) / 2);
  border: calc(var(--ring-border-radius) / 4) solid var(--ring-borders-color);

  &.selected__dbf {
    background-color: var(--ring-selected-background-color);

    .sideContainer__d6f {
      background-color: var(--ring-selected-background-color);
      box-shadow: 0 0 8px 5px var(--ring-selected-background-color);
    }
  }
}

.bodyContainer__b44.variantFlat__b46 {
  &.selected__dbf {
    background-color: var(--ring-hover-background-color);

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 100%;
      background-color: var(--ring-action-link-color);
    }
  }
}

.content__a79 {
  display: flex;
}

.bodyContainer__b44.variantBordered__fc5:hover:not(.selected__dbf):not(.nonInteractive__a69) {
  background-color: var(--ring-hover-background-color);
}

.bodyContainer__b44.variantFlat__b46:hover:not(.selected__dbf):not(.nonInteractive__a69) {
  background-color: var(--ring-hover-background-color);
}

.bodyContainer__b44:hover .actionIcon__a85 {
  color: var(--ring-icon-color);
  visibility: visible;
}

.bodyContainer__b44:hover .actionIcon__a85:hover {
  color: var(--ring-icon-hover-color);
}

.sideContainer__d6f {
  position: absolute;
  right: 0;
  top: calc(var(--ring-unit) * 0.5);

  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: flex-start;
  padding-right: var(--ring-unit);
}

.iconsContainer__d00 {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: calc(var(--ring-unit));
}

.actionIcon__a85 {
  visibility: hidden;
  z-index: 10;
}

.badge__e4c.badge__e4c {
  background-color: var(--ring-warning-background-color);
  color: var(--ring-warning-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/profiles/profile-details/profile-ide-provisioner/common/setting-layout.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;;EAEnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,2EAA2E;;EAE3E;IACE,uDAAuD;;IAEvD;MACE,uDAAuD;MACvD,6DAA6D;IAC/D;EACF;AACF;;AAEA;EACE;IACE,oDAAoD;;IAEpD;MACE,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,UAAU;MACV,YAAY;MACZ,+CAA+C;IACjD;EACF;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;;EAEjC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sDAAsD;EACtD,gCAAgC;AAClC","sourcesContent":[".bodyContainer {\n  z-index: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 44px;\n  position: relative;\n  padding: calc(var(--ring-unit) / 2);\n\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.bodyContainer.nonInteractive {\n  cursor: default;\n}\n\n.bodyContainer.variantBordered {\n  margin-bottom: calc(var(--ring-unit) / 2);\n  border-radius: calc(var(--ring-unit) / 2);\n  border: calc(var(--ring-border-radius) / 4) solid var(--ring-borders-color);\n\n  &.selected {\n    background-color: var(--ring-selected-background-color);\n\n    .sideContainer {\n      background-color: var(--ring-selected-background-color);\n      box-shadow: 0 0 8px 5px var(--ring-selected-background-color);\n    }\n  }\n}\n\n.bodyContainer.variantFlat {\n  &.selected {\n    background-color: var(--ring-hover-background-color);\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 2px;\n      height: 100%;\n      background-color: var(--ring-action-link-color);\n    }\n  }\n}\n\n.content {\n  display: flex;\n}\n\n.bodyContainer.variantBordered:hover:not(.selected):not(.nonInteractive) {\n  background-color: var(--ring-hover-background-color);\n}\n\n.bodyContainer.variantFlat:hover:not(.selected):not(.nonInteractive) {\n  background-color: var(--ring-hover-background-color);\n}\n\n.bodyContainer:hover .actionIcon {\n  color: var(--ring-icon-color);\n  visibility: visible;\n}\n\n.bodyContainer:hover .actionIcon:hover {\n  color: var(--ring-icon-hover-color);\n}\n\n.sideContainer {\n  position: absolute;\n  right: 0;\n  top: calc(var(--ring-unit) * 0.5);\n\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding-right: var(--ring-unit);\n}\n\n.iconsContainer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: calc(var(--ring-unit));\n}\n\n.actionIcon {\n  visibility: hidden;\n  z-index: 10;\n}\n\n.badge.badge {\n  background-color: var(--ring-warning-background-color);\n  color: var(--ring-warning-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyContainer": `bodyContainer__b44`,
	"nonInteractive": `nonInteractive__a69`,
	"variantBordered": `variantBordered__fc5`,
	"selected": `selected__dbf`,
	"sideContainer": `sideContainer__d6f`,
	"variantFlat": `variantFlat__b46`,
	"content": `content__a79`,
	"actionIcon": `actionIcon__a85`,
	"iconsContainer": `iconsContainer__d00`,
	"badge": `badge__e4c`
};
export default ___CSS_LOADER_EXPORT___;
